/* eslint-disable */
import * as React from "react";
import { ContextReport1 } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useData1 } from "../data/useData1";
import { useData2 } from "../data/useData2";
import { useChart1 } from "../transformers/useChart1";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart, { Chartpoint } from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import {
  useParameter,
  useDictionaryItem,
  yearToCropYearShort,
  GLOBAL_UNIT,
  castUnit,
  useExport,
  useSubscriptionProviderContext,
} from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { first } from "lodash";

export const ComponentChart1: React.FC<{ context: ContextReport1 }> = (props) => {
  const {
    actions: { setSource },
  } = useSubscriptionProviderContext();

  const context = props.context;
  const orderedCountriesIds = useHookSubscribe(null, context.orderedCountriesIds$);
  const olapCountriesProduction = useHookSubscribe(null, context.olapCountriesProduction$);
  const olapCountriesYield = useHookSubscribe(null, context.olapCountriesYield$);
  const olapCountriesArea = useHookSubscribe(null, context.olapCountriesArea$);
  const olapWorldProduction = useHookSubscribe(null, context.olapWorldProduction$);

  const worldStart = castUnit(olapWorldProduction?.data.rows[0]?.cells[0]?.value, GLOBAL_UNIT.PRODUCTION_MMT, GLOBAL_UNIT.PRODUCTION_MMT);
  const worldEnd = castUnit(olapWorldProduction?.data.rows[1]?.cells[0]?.value, GLOBAL_UNIT.PRODUCTION_MMT, GLOBAL_UNIT.PRODUCTION_MMT);

  const productionByYear = useData1(olapCountriesProduction); // production by year
  const yieldByYear = useData1(olapCountriesYield); // yield by year
  const areaHarvestedByYear = useData1(olapCountriesArea); // Area harvested by year

  const chartTransformData = React.useMemo(() => {
    return { areaHarvestedByYear, productionByYear, yieldByYear, orderedCountriesIds };
  }, [areaHarvestedByYear, productionByYear, yieldByYear, orderedCountriesIds]);

  const chartData = useChart1(chartTransformData);
  const source = useHookSubscribe(null, context.sources$);
  const exportBuilder = useExport();
  React.useEffect(() => {
    exportBuilder.set("source", source);
    setSource(source);
  }, [source]);

  const [parameterValues] = useParameter<number[]>("@calendar");
  const [, calendarName] = useDictionaryItem(dictionaryService, "slides-calendar", first(parameterValues));
  const year = calendarName ? Number(calendarName) : new Date().getFullYear() - 1;

  const title = `World production: ${yearToCropYearShort(year - 4)}: ${
    worldStart ? `${worldStart.toFixed(0)} mmt` : ""
  } - ${yearToCropYearShort(year)}: ${worldEnd ? `${worldEnd.toFixed(0)} mmt` : ""}`;

  const handleChartHover = (point: Chartpoint | undefined) => {
    context.highlightData.next(point?.attributes || {});
  };
  if (window["exportMode"]) {
    window["exportReady"] = chartData && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (!window["exportMode"] && (!chartData || context.readyState === ComponentContextReadyState.Loading)) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <ComponentTitle>{title}</ComponentTitle>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <HighchartsChart data={chartData} loader={<ComponentPreloader />} onHover={handleChartHover} />
    </>
  );
};
